import { User } from 'models/User';
import { Role } from 'searchality-data';

export default {
  checkRolesForUser(user: User, roles: Role[]) {
    return roles.includes(user.role);
  },
};
